import React, { Component } from "react";
import Logo from "../logo2.png";
import Payment from "../images/payments.png";
import { Link } from "react-router-dom";

export default class FooterSection extends Component {
  render() {
    return (
      <section className="footer-section">
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-sm-6">
              <div className="footer-widget">
                <div className="about-text">
                  <Link to="/">
                    <img src={Logo} alt="Footer logo" />
                  </Link>
                  <p>
                    Sed ut perspiciatis unde omnis iste natus error sit
                    voluptatem accus antium doloremque laudantium, totam rem
                    aperiam, eaque ipsa quae ab illo inventore veritatis
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="footer-widget">
                <div className="footer-title mt-30">
                  <h3>Useful links</h3>
                </div>
                <ul className="footer-link">
                  <li>
                    <a href="#">About</a>
                  </li>
                  <li>
                    <a href="#">Login</a>
                  </li>
                  <li>
                    <a href="#">Register</a>
                  </li>
                  <li>
                    <a href="#">News & Events</a>
                  </li>
                  <li>
                    <a href="#">Contacts</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="footer-widget">
                <div className="footer-title mt-30">
                  <h3>Contact with us</h3>
                </div>
                <ul className="contact-list">
                  <li>
                    <div className="media">
                      <i className="fa fa-mobile" style={{ fontSize: 22 }}></i>
                      <div className="media-body">
                        <div>5676567665, 6564765656</div>
                        <div>(WhatsApp, Viber, IMO)</div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="media">
                      <i className="fa fa-envelope"></i>
                      <div className="media-body">
                        <div>ask@24tkt.com, hello@24tkt.com</div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="footer-widget">
                <div className="footer-title mt-30">
                  <h3>Follow us</h3>
                </div>
                <ul className="footer-social">
                  <li>
                    <a href="">
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="copyright-section">
                <div className="row">
                  <div className="col-md-6">
                    <div className="payments-img">
                      <Link to="/">
                        <img src={Payment} alt="Footer logo" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <ul className="copyright-link">
                      <li>
                        <a href="#">Terms and conditions</a>
                      </li>
                      <li>
                        <a href="#">Privacy</a>
                      </li>
                      <li>&copy; 2019 24tkt.com</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
